export function getJwtToken() {
    return localStorage.getItem('jwtToken');
  }

  // Function to remove the token from localStorage (e.g., on logout)
export function removeJwtToken() {
  localStorage.removeItem('jwtToken');
}